
import { Box, Center, Text } from "@chakra-ui/react"

export const UpperHeading = () => {
    return (
        <Box p={6}>
            <Center><Text fontSize={{ base: '12px', sm: '16px', md: '20px', lg: '24px'}} color='#666666'> Tata 1mg: India’s Leading Online Pharmacy & Healthcare Platform </Text></Center>
        </Box>
    )
}